export const arrowLists = [
  {
    id: 1,
    STEP: "01",
    DESCRIP1: "SILICON",
    DESCRIP2: "PROCESS",
    TOPIMAGE: false,
    BOTTOMIMAGE: false,
  },
  {
    id: 2,
    STEP: "02",
    DESCRIP1: "FAB",
    DESCRIP2: "PROCESS",
    TOPIMAGE: "DHKS",
    BOTTOMIMAGE: false,
  },
  {
    id: 3,
    STEP: "03",
    DESCRIP1: "WAFTER TEST",
    DESCRIP2: "PROCESS",
    TOPIMAGE: false,
    BOTTOMIMAGE: "semcns",
  },
  {
    id: 4,
    STEP: "04",
    DESCRIP1: "ASSEMBLY",
    DESCRIP2: "PROCESS",
    TOPIMAGE: "DHKS",
    BOTTOMIMAGE: false,
  },
  {
    id: 5,
    STEP: "05",
    DESCRIP1: "PACKAGING",
    DESCRIP2: "PROCESS",
    TOPIMAGE: false,
    BOTTOMIMAGE: false,
  },
  {
    id: 6,
    STEP: "06",
    DESCRIP1: "PACKAGING",
    DESCRIP2: "TEST PROCESS",
    TOPIMAGE: false,
    BOTTOMIMAGE: "exicon",
  },
];

export const PRODUCT_DATA = [
  {
    id: 1,
    name: "Dicing Saw",
    desc: "반도체 웨이퍼를 칩 단위로 잘라주는 초정밀 절단기",
    icon: "01",
    img: "dicing.jpg",
    path: "https://www.disco.co.jp/kr/products/index.html?id=dicing",
  },
  {
    id: 2,
    name: "Laser Saw",
    desc: "레이저로 웨이퍼를 비접촉 절단하는 장비",
    icon: "02",
    img: "laser.jpg",
    path: "https://www.disco.co.jp/kr/products/index.html?id=laser",
  },
  {
    id: 3,
    name: "Grinder",
    desc: "웨이퍼 두께를 얇게 만드는 연마 장비",
    icon: "03",
    img: "grinder.jpg",
    path: "https://www.disco.co.jp/kr/products/index.html?id=grinding",
  },
  {
    id: 4,
    name: "Polisher & Dry Etcher",
    desc: "정밀 연마 장비 & 비접촉 식각 장비",
    icon: "04",
    img: "polisher.jpg",
    path: "https://www.disco.co.jp/kr/products/index.html?id=Polisher",
  },
  {
    id: 5,
    name: "Blade & Wheel",
    desc: "절단과 연마를 실제로 수행하는 소모성 공구(날과 휠)",
    icon: "05",
    img: "blade.jpg",
    path: "https://www.disco.co.jp/kr/products/index.html?id=hub&hubless",
  },
  {
    id: 6,
    name: "Wafer and die processing solutions",
    desc: "웨이퍼부터 개별 칩까지 전 공정을 아우르는 통합 솔루션",
    icon: "06",
    img: "dieprocessing.jpg",
    path: "https://www.disco.co.jp/kr/products/index.html?id=separation",
  },
];

export const CONTACT_DATA = [
  {
    category: "SALES",
    title: "영업",
    items: [
      { area: "Machine", tel: "031-639-9059", email: "sales@dhk.co.kr" },
      { area: "Blade & Wheel", tel: "031-639-9052", email: "sales@dhk.co.kr" },
      { area: "Parts", tel: "031-639-9052", email: "sales@dhk.co.kr" },
    ],
  },
  {
    category: "TECHNICAL SUPPORT",
    title: "기술 지원",
    items: [
      {
        area: "Grinder",
        tel: "031-639-9000",
        email: "grinder@dhk.co.kr",
      },
      {
        area: "Laser Saw",
        tel: "031-639-9000",
        email: "laser@dhk.co.kr",
      },
      {
        area: "Dicing Saw",
        tel: "031-639-9000",
        email: "saw@dhk.co.kr",
      },
      {
        area: "Wafer & die Processing Solutions",
        tel: "031-639-9000",
        email: "support@dhk.co.kr",
      },
      {
        area: "Dicing Saw 유상가공 Service",
        tel: "031-639-9051",
        email: "ansan@dhk.co.kr",
      },
    ],
  },
];

export const HISTORY_DATA = [
  {
    year: "2025",
    title: "",
    desc: "",
    events: [{ date: "03월", content: "기술혁신형 중소기업·벤처기업 인증" }],
  },
  {
    year: "2022",
    title: "Community & Expansion",
    desc: "동탄 사무소 개소 및 모범 납세자 선정 등 사회적 책임 완수",
    events: [
      { date: "12월", content: "충청남도 아산시 모범 납세자 선정" },
      { date: "05월", content: "동탄 사무소 개소" },
      { date: "02월", content: "경기도 성남시 성실 납세자 선정" },
    ],
  },
  {
    year: "2021",
    title: "Talent Development",
    desc: "미래 인재 양성을 위한 전문 교육 인프라 구축",
    events: [
      { date: "04월", content: "아산 Training Center OPEN (아산 KKM學院)" },
    ],
  },
  {
    year: "2018",
    title: "Network Expansion",
    desc: "지역별 거점 확대를 통한 고객 서비스 대응력 강화",
    events: [{ date: "07월", content: "아산 사무소 개소" }],
  },
  {
    year: "2014",
    title: "New Headquarters Era",
    desc: "판교 사옥 이전 및 Application Center 공식 개소",
    events: [
      { date: "07월", content: "디에이치케이솔루션 본점 판교 사옥 이전" },
      { date: "05월", content: "신 사옥 AP Center 개소" },
    ],
  },
  {
    year: "2013",
    title: "Infrastructure Completion",
    desc: "판교 신축 빌딩 준공 및 연구 시설 통합 운영 시작",
    events: [
      {
        date: "09월",
        content: "신축 빌딩 준공 및 판교 Application Center, R&D Center 설립",
      },
    ],
  },
  {
    year: "2012",
    title: "Innovation Certified",
    desc: "기술 혁신 및 벤처 기업 인증을 통한 공신력 확보",
    events: [
      {
        date: "03월",
        content: "기술혁신형 중소기업 (INNO-BIZ)인증 <중소기업청>",
      },
    ],
  },
  {
    year: "2011",
    title: "Pangyo Foundation",
    desc: "미래 성장의 핵심 기지, 판교테크노밸리 진출",
    events: [{ date: "04월", content: "판교테크노밸리 내 신축 빌딩 착공" }],
  },
  {
    year: "2010",
    title: "R&D Growth",
    desc: "연구 전문 부서 설립 및 기술 거점 확대",
    events: [
      { date: "07월", content: "연구전담부서 설립 인가" },
      { date: "06월", content: "안산 Application Center 설립" },
    ],
  },
  {
    year: "2006",
    title: "The Genesis",
    desc: "DHK Solution 법인 설립 및 사업 본격화",
    events: [
      {
        date: "09월",
        content:
          "Application Center 설립을 위한 R&D Center 판교테크노밸리 계약",
      },
      { date: "08월", content: "사업 시작" },
      { date: "07월 04일", content: "법인 설립" },
    ],
  },
];

export const MENU_DATA = [
  {
    title: "회사소개",
    path: "/company/greeting",
    subMenus: [
      { title: "인사말", path: "/company/greeting" },
      { title: "연혁", path: "/company/history" },
      { title: "오시는 길", path: "/company/location" },
    ],
  },
  {
    title: "제품소개",
    path: "/",
    subMenus: [
      {
        title: "Dicinig Saw",
        path: "https://www.disco.co.jp/kr/products/index.html?id=dicing",
        newPage: true,
      },
      {
        title: "Laser Saw",
        path: "https://www.disco.co.jp/kr/products/index.html?id=laser",
        newPage: true,
      },
      {
        title: "Grinder",
        path: "https://www.disco.co.jp/kr/products/index.html?id=grinding",
        newPage: true,
      },
      {
        title: "Polisher & Dry Etcher",
        path: "https://www.disco.co.jp/kr/products/index.html?id=Polisher",
        newPage: true,
      },
      {
        title: "Blade & Wheel",
        path: "https://www.disco.co.jp/kr/products/tool.html?id=hub&hubless",
        newPage: true,
      },
      {
        title: "Wafer and die processing solutions",
        path: "https://www.disco.co.jp/kr/products/index.html?id=separation",
        newPage: true,
      },
    ],
  },
  {
    title: "고객지원",
    path: "/support/contact",
    subMenus: [
      { title: "부문별 담당", path: "/support/contact" },
      { title: "게시판", path: "/support/notice" },
    ],
  },
  {
    title: "채용",
    path: "/recruit",
    subMenus: [{ title: "인재채용", path: "/recruit" }],
  },
];

export const SLIDE_DATA = [
  {
    id: 0,
    label: "",

    title: "DHK Solution",
    desc: "Bringing science to comfortable living through advanced",
    subDesc: "Cutting, Grinding, Polishing technologies.",
    img: "bg0.jpg",
  },
  // {
  //   id: 1,
  //   label: "INNOVATION",
  //   title: "새로운 가치의 창출",
  //   desc: "전 세계의 지식과 열정으로 고객의 비즈니스 과제를 해결하는 최적의 솔루션을 제공합니다.",
  //   img: "bg1.jpg",
  // },
  // {
  //   id: 2,
  //   label: "CREATIVE",
  //   title: "비즈니스의 혁신",
  //   desc: "정해진 틀을 벗어난 유연한 시각으로 고객 맞춤형 비즈니스의 핵심입니다.",
  //   img: "bg2.jpg",
  // },
  // {
  //   id: 3,
  //   label: "PARTNERSHIP",
  //   title: "신뢰와 동반성장",
  //   desc: "고객과의 굳건한 신뢰를 최우선으로 생각합니다.",
  //   img: "bg3.jpg",
  // },
];
